import { lazy } from 'react';

const Searcher = lazy(() => import('./Searcher'));

export default Searcher;
